 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		38: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","6":"vendors~GDPRPrompt~PlaylistPage~PlaylistWrapped~teamGmTools~teamScores~teamSquads","7":"vendors~GamePage~PlaylistPage~PlaylistWrapped~TeamPage~scheduleWidget","8":"GDPRPrompt","9":"vendors~GDPRPrompt","10":"vendors~GamePage-Details~userHandOfGodInspector~userHeader","11":"vendors~GamePage~TeamPage~userHeader","13":"GamePage-Details~ssUiGameVenue","14":"vendors~GamePage~WidgetCreatorsPage","15":"vendors~UserWidgetsPage~ssUiPremiumWidgetSubscriptions","16":"vendors~teamNoMatch~userHandOfGodInspector","17":"EmbedHeader","18":"FrontPage","19":"GamePage","20":"GamePage-Chat","21":"GamePage-Details","22":"GamePage-Fans","23":"GamePostPage","24":"HandOfGod","25":"HeaderFrontPage","26":"Internal-NotificationsPage","27":"Internal-SystemMetricsPage","28":"InternalPage","29":"NoMatchPage","30":"NotificationsPage","31":"PlaylistPage","32":"PlaylistWrapped","33":"TeamPage","34":"UpdateGameModal","35":"UserPage","36":"UserWidgetsPage","37":"WidgetCreatorsPage","39":"cachedLevelsOfPlay","40":"logosAndSponsors","41":"scheduleWidget","42":"ssTeamScheduleWidget","43":"ssUiGameVenue","44":"ssUiPremiumWidgetSubscriptions","45":"ssUiTeamOverrideManager","46":"ssUiTeamScheduleWidget","47":"ssUiTeamVenueManager","48":"ssUiTrendingList","49":"ssUiVenueTypeToFind","50":"teamChat","51":"teamFans","52":"teamGames","53":"teamGmTools","54":"teamMain","55":"teamMedia","56":"teamNoMatch","57":"teamScheduleCreator","58":"teamScheduleCreatorForm","59":"teamScores","60":"teamSquads","61":"userEdit","62":"userEditCommunicationSettings","63":"userFollowers","64":"userFollowing","65":"userHandOfGodInspector","66":"userHeader","67":"userMedia","68":"userPage","69":"userTeams","70":"vendors~FrontPage","71":"vendors~GamePage-Fans","72":"vendors~Internal-NotificationsPage","73":"vendors~Internal-SystemMetricsPage","74":"vendors~NotificationsPage","75":"vendors~UserWidgetsPage","76":"vendors~scheduleWidget","77":"vendors~userEditCommunicationSettings","78":"vendors~userHandOfGodInspector"}[chunkId]||chunkId) + "." + {"0":"377bf4bf8938bb6c14f9","1":"708b1d3136165d1d1883","2":"6cccabaf0cf7b95a59ec","3":"364a10d7c146bb566278","4":"cfc8798a44b1d692e23b","5":"39d8d321d49b523dcbc1","6":"c077f6f87126f30f75e6","7":"830a18c21dd552c35197","8":"f1984210f6954f07ec6f","9":"ada922948250b25975db","10":"22c46c5d16c72bdb452b","11":"fda784f4aef1ef8ca565","12":"8398cefa6e5a7262b6f4","13":"76a7848370e32df6e373","14":"c9e16601f0cad3dc37b0","15":"dde5b7a1f6542c1d8b9d","16":"2a88a56a5120c3a2fa20","17":"bfc7f65e47c9b3c0a0a2","18":"fb578ccfeff98d360bae","19":"0b2c48db8b21060fe26e","20":"651caec45f263ae71127","21":"a3e0a4320506a3215ba0","22":"dd3ae2c7e4a4e4152573","23":"854fea9d10ecf93f50c6","24":"d7bce2cea88d0bc6d3ba","25":"2e7c1ef486f47da21a5a","26":"5d0c1756558d200f5989","27":"499b5088ca8d615ce0e1","28":"f57bbea2c73af45d154c","29":"e33e2bf458010669fb23","30":"12f1c1358a4627ef4be6","31":"75d74aa5c5bc4c28cf04","32":"0555081e6456e494afac","33":"c5d9d93c4daf15a1b38f","34":"9a1c37adabc04eeb2c91","35":"2a7d173b9027f977928a","36":"43f0fae1e10fc90b8af7","37":"a74d930d629240e7bfce","39":"1bc649052ae80f2aeaed","40":"a12ffafe6e31e8878be5","41":"cd9689d2758abe7babf5","42":"de12ec58630b0936054a","43":"1a0ec92ce4a8a738a3ef","44":"aca7074c2edf65b76986","45":"00025f4e9d2b18127579","46":"33cea0f7f15a711d166b","47":"a141123b8ece3a993d8d","48":"6abaa5f335212947d1f3","49":"3febbdf4699e87faaa60","50":"585c90046bb251ab6005","51":"bb591e67c336ab3e6d49","52":"0be836e39ded772dd320","53":"f0e92d7e8874e63ab004","54":"3e4cdd5fb7ffeeddaf0c","55":"9fe88f618da1c4480663","56":"976b0de6cc0ade84400c","57":"bf31bea9504a526eec64","58":"7a357a34a80270606c20","59":"c99df34af18c320b3960","60":"23bb46224bdf889fdb8e","61":"48a8f797fd91a621ee85","62":"157114aec27aec1331da","63":"bd5ea6192c7d2a66bb0c","64":"3e4bcff32fa8df600ec7","65":"79eaec4b4fa09f35d5dd","66":"ae86928003e83173e13f","67":"f6a5537b0cde8d74d0f2","68":"698abb313703ec608411","69":"632602ac2acca928849f","70":"c85e2281bff71415ff38","71":"308a70916e0d697ce97c","72":"a0d049fab15d45837864","73":"bd5bb43cf50719b20597","74":"704d75bcf1cad5c919b5","75":"6d46ea4384b8cba0d1c1","76":"a609aa3d237887ebec3a","77":"434a6f7ba0d8de1117b1","78":"6fae707472f56d4d3ad9","79":"4eb0f6e0eb7bc6dd5788","80":"164e8ad1e8bd2bed1ee0","81":"68bce8ad37b33c4710d8","82":"a7aabcf2a52f88111124","83":"56817dc47ba17263047c","84":"ec1f7ee1609d2b0cd2f0","85":"c6413f069fd2a46d060c","86":"4d428da7737120cfb6a7","87":"02a5db9e29ccc11b00f3","88":"a983ed5c5159b4a9ec71","89":"7197dfae908cc4319a43","90":"9684562ef76c421114da"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + chunkId + ".extractedFromBundle." + "7da684fb4c406742f713" + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "realtime/app";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["ssuiWebpackJsonp"] = window["ssuiWebpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 824);
